/**
 * Minimal SuperJSON-compatible transformer so the CLI speaks the platform tRPC
 * server's `{ json, meta? }` wire format (log payloads are JSON-native, so no
 * `meta` revival is needed). Without it, remote calls fail to deserialize.
 */
export const superjsonLite = {
  serialize: (object: unknown) => ({ json: object }),
  deserialize: (payload: unknown) =>
    payload && typeof payload === "object" && "json" in payload
      ? (payload as { json: unknown }).json
      : payload,
};
